// extracted by mini-css-extract-plugin
module.exports = {"addTagsWindow":"addTagsWindow__VAkWk"};